module.exports = __webpack_public_path__ + "static/media/hStream_signin_img.4d11e8d4.png";